import React from 'react';

const Lock = (props: React.SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 28 32" {...props}>
    <g fill="currentColor" transform="scale(0.028)">
      <path d="M480 701.269v0c-18.643-6.589-32-24.369-32-45.269 0-26.51 21.49-48 48-48s48 21.49 48 48c0 20.9-13.357 38.679-32 45.269v83.019c0 8.42-7.163 15.712-16 15.712-8.578 0-16-7.035-16-15.712v-83.019zM256 448v0 0c-53.045 0.15-96 42.866-96 96.303v319.393c0 53.187 43.059 96.303 96.281 96.303h479.438c53.175 0 96.281-42.772 96.281-96.303v-319.393c0-53.093-42.907-96.151-96-96.303v-112.025c0-132.535-107.721-239.976-240-239.976-132.548 0-240 107.415-240 239.976v112.025zM352 448v-111.973c0-79.731 64.471-144.027 144-144.027 79.367 0 144 64.483 144 144.027v111.973h-288z" />
    </g>
  </svg>
);

export default Lock;
